import React, { FC } from 'react';
import { DecisionStateRender } from './DecisionStateRender';
import { ApprovalTermsRender } from './ApprovalTermsRender';
import { ConditionsFeesRender } from './ConditionsFeesRender';
import { InitialCreationRender } from './InitialCreationRender';
import { CreditSubmissionChangeType } from '../../../api';
import {
  DecisionStateChanges,
  ApprovalTermsChanges,
  ConditionsFeesChanges,
  CreditSubmissionChangeLog,
  CreditSubmissionChangeLogTableRow,
} from '../../../types';

interface ChangesCellProps {
  log: CreditSubmissionChangeLogTableRow;
}

export const ChangesCell = ({ log }: ChangesCellProps) => {
  const CHANGE_TYPE_RENDER_MAP: Record<CreditSubmissionChangeType, FC<{ changes: CreditSubmissionChangeLog }> | null> =
    {
      INITIAL_CREATION: () => <InitialCreationRender />,
      DECISION_STATE: ({ changes }) => <DecisionStateRender changes={changes as DecisionStateChanges} />,
      APPROVAL_TERMS: ({ changes }) => <ApprovalTermsRender changes={changes as ApprovalTermsChanges} />,
      CONDITIONS_FEES: ({ changes }) => <ConditionsFeesRender changes={changes as ConditionsFeesChanges} />,
    };

  const Component = CHANGE_TYPE_RENDER_MAP[log.changeType];

  if (!Component) return null;

  return <Component changes={log.changes} />;
};
